import './ui/styles.css';
import 'katex/dist/katex.min.css';
import { App } from './harness/App';
import { Router } from './harness/Router';
import { findSketch } from './harness/registry';
import { installGestureGuards } from './core/kiosk/gestures';
import { enableOnFirstGesture } from './core/kiosk/fullscreen';
import { WakeLock } from './core/kiosk/wakelock';

const root = document.getElementById('app');
if (!root) throw new Error('#app not found');

// Kiosk guards: kill browser gestures, hold the screen awake, go fullscreen on
// the first tap.
installGestureGuards();
enableOnFirstGesture(document.documentElement);
void new WakeLock().request();

// The hash route is the single source of truth: UI callbacks navigate, the
// router drives the App.
let router: Router;
const app = new App(
  root,
  (id) => router.go({ kind: 'sketch', id }),
  () => router.go({ kind: 'menu' }),
);

router = new Router((route) => {
  if (route.kind === 'menu') {
    app.showMenu();
  } else {
    const meta = findSketch(route.id);
    if (meta) void app.open(meta);
    else router.go({ kind: 'menu' });
  }
});

router.start();
app.loop();
